import { Task, TaskStatus } from "../types";
import { PartnerTasksAdapter } from "../adapters/PartnerTasksAdapter";
import {
  getTasksGroupDetails,
  postPartnerTasksGetReward,
} from "../../../Services/Requests";

export class PartnersService {
  private static sortTasksByStatus(tasks: Task[]): Task[] {
    const getPriority = (task: Task): number => {
      // Задания которые можно собрать (DONE)
      if (task.status === 'DONE') return 1;
      
      // Задания которые можно выполнить (NOT_STARTED или IN_PROGRESS)
      if (task.status === 'NOT_STARTED' || task.status === 'IN_PROGRESS') return 2;
      
      // Собранные без подписки
      if (task.status === 'CLAIMED' && task.is_subscribed === false) return 3;
      
      // Собранные с подпиской
      if (task.status === 'CLAIMED' && task.is_subscribed === true) return 4;
      
      return 5; // Для всех остальных случаев
    };


    return tasks.sort((a, b) => {
      const priorityA = getPriority(a);
      const priorityB = getPriority(b);
      
      if (priorityA === priorityB) {
        // Если приоритеты равны, рандомизируем порядок для NOT_STARTED
        if (a.status === 'NOT_STARTED' && b.status === 'NOT_STARTED') {
          return Math.random() - 0.5;
        }
        return 0;
      }
      
      return priorityA - priorityB;
    });
  }

  static async getPartnerTasks(groupId: number): Promise<Task[]> {
    console.log("🚀 PartnersService.getPartnerTasks - start");

    try {
      return new Promise((resolve, reject) => {
        getTasksGroupDetails(groupId, (response: any) => {
          console.log(
            "✨ PartnersService.getPartnerTasks - response",
            response
          );
          try {
            const adaptedTasks = PartnerTasksAdapter.adaptTasks(response);
            const sortedTasks = this.sortTasksByStatus(adaptedTasks);
            resolve(sortedTasks);
          } catch (error) {
            reject(error);
          }
        });
      });
    } catch (error) {
      console.error("❌ PartnersService.getPartnerTasks - error", error);
      throw error;
    }
  }

  static async claimPartnerTask(taskId: number, groupId: number): Promise<any> {
    try {
      const response = await postPartnerTasksGetReward(taskId);
      setTimeout(() => {
        getTasksGroupDetails(groupId, (response: any) => {
          console.log("✨ PartnersService.claimPartnerTask - updated tasks", response);
          try {
            const adaptedTasks = PartnerTasksAdapter.adaptTasks(response);
            const sortedTasks = this.sortTasksByStatus(adaptedTasks);
            return sortedTasks;
          } catch (error) {
            console.error("❌ PartnersService.claimPartnerTask - error updating tasks", error);
          }
        });
      }, 1000);
      return response;
    } catch (error) {
      console.error("❌ PartnersService.claimPartnerTask - error", error);
      throw error;
    }
  }
}
